const routeOptions = {
  "nuts-fruits-party-packs": [
    {
      type: "checkbox",
      variantIds: [31230154276934, 48635808591, 29554381815878, 42224494739526],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions25,
    },
    {
      type: "checkbox",
      variantIds: [40682908549190, 40682908581958, 40682908614726],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions95,
    },
    {
      type: "imageSelect",
      variantIds: [31230154276934, 40682908549190, 42224494739526],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions,
    },
    {
      type: "imageSelect",
      variantIds: [48635808591, 29554381815878, 40682908581958, 40682908614726],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions.concat([
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ]),
    },
    {
      type: "imageSelect",
      variantIds: [41239587848262],
      qty: 1,
      name: "Label",
      label: "Upload your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: [
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ],
    },
    {
      type: "display",
      variantIds: [32262394183750],
      html: `<p>Box only excludes snacks</p>`,
    },
  ],
  "biscuits-party-packs": [
    {
      type: "checkbox",
      variantIds: [31230183702598, 48635542479, 40279310139462, 42948443144262],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: biscuitOptions25,
    },
    {
      type: "checkbox",
      variantIds: [40682902421574, 40682902454342, 40682902487110],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: biscuitOptions95,
    },
    {
      type: "imageSelect",
      variantIds: [31230183702598, 40682902421574, 42948443144262],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions,
    },
    {
      type: "imageSelect",
      variantIds: [48635542479, 40279310139462, 40682902454342, 40682902487110],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions.concat([
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ]),
    },
    {
      type: "imageSelect",
      variantIds: [42948443111494],
      qty: 1,
      name: "Label",
      label: "Upload your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: [
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ],
    },
  ],
  "cookies-party-packs-gift-packs": [
    {
      type: "checkbox",
      variantIds: [40636064858182, 40636064890950, 40636064923718, 40694286155846],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cookieOptions25,
    },
    {
      type: "checkbox",
      variantIds: [40694208364614, 40694208397382, 40694208430150, 40694286188614],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cookieOptions95,
    },
    {
      type: "imageSelect",
      variantIds: [40636064858182, 40694208364614, 40694286155846, 40694286188614],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions,
    },
    {
      type: "imageSelect",
      variantIds: [40636064890950, 40636064923718, 40694208397382, 40694208430150],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions.concat([
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ]),
    },
  ],
  "snacks-goodie-box": [
    {
      type: "checkbox",
      variantIds: [43711299551302, 43711299584070, 43711299616838],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711299878982],
      maxChecked: 3,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 3 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: goodieBoxOptions,
    },
  ],
  "snacks-snackie-box": [
    {
      type: "checkbox",
      variantIds: [42041830703174, 42041830768710, 42041830834246],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43703800889414],
      maxChecked: 6,
      qty: 1,
      name: "Flavours",
      label: "Choose 6 flavours",
      tooltip: "We will apportion your selected flavours equally if necessary",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42088692383814],
      maxChecked: 1,
      qty: 1,
      name: "Flavours",
      label: "Choose 1 Goodie Box",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42088692383814],
      maxChecked: 1,
      qty: 1,
      name: "Flavours",
      label: "Choose 1 Snackie Box",
      snacks: snackieBoxOptions,
    },
    {
      type: "textField",
      variantIds: [42088692383814, 43703800889414],
      name: "Message",
      label: "Your message on card",
    },
  ],
  "snacks-in-cutie-box": [
    {
      type: "checkbox",
      variantIds: [42948940628038, 42948940660806, 42948940693574],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected snacks equally",
      snacks: cutieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43142772916294],
      maxChecked: 4,
      qty: 1,
      name: "Cutie Boxes",
      label: "Choose up to 4 Cutie Boxes",
      tooltip: "We will apportion your selected snacks equally",
      snacks: cutieBoxOptions,
    },
  ],
  "custom-snacks-display-box": [
    {
      type: "checkbox",
      variantIds: [40308392493126, 40686879932486],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions25,
    },
    {
      type: "imageSelect",
      variantIds: [40308392493126, 40686879932486],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5.5cm x 4.5cm",
      images: imageOptions,
    },
  ],
  "retail-packs": [
    {
      type: "checkbox",
      variantIds: [40731447853126, 40275672334406, 40706726068294],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions200,
    },
  ],
  "custom-snack-box": [
    {
      type: "checkbox",
      variantIds: [42438179848262],
      maxChecked: 3,
      qty: 1,
      name: "Retail Pack",
      label: "Choose up to 3 retail packs",
      snacks: biscuitOptionsRetail,
    },
    {
      type: "checkbox",
      variantIds: [31598564769862],
      maxChecked: 3,
      qty: 1,
      name: "Retail Pack",
      label: "Choose up to 3 retail packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "checkbox",
      variantIds: [41076791476294],
      qty: 1,
      maxChecked: 2,
      name: "Retail pack",
      label: "Choose up to 2 retail packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions200,
    },
    {
      type: "checkbox",
      variantIds: [41076791476294],
      qty: 1,
      maxChecked: 2,
      name: "Snackie Box",
      label: "Choose up to 2 Snackie Boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41085747429446],
      qty: 1,
      maxChecked: 1,
      name: "Retail pack",
      label: "Choose 1 retail pack",
      snacks: popularSnackOptions200,
    },
    {
      type: "checkbox",
      variantIds: [41085747429446],
      qty: 1,
      maxChecked: 2,
      name: "Snackie Box",
      label: "Choose up to 2 Snackie Boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41085747429446],
      qty: 1,
      maxChecked: 2,
      name: "Goodie Box",
      label: "Choose up to 2 Goodie Boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42088932245574],
      qty: 1,
      maxChecked: 6,
      name: "Snackie Box",
      label: "Choose up to 6 Snackie Boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42107179073606],
      qty: 1,
      maxChecked: 4,
      name: "Party packs",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions25,
    },
    {
      type: "checkbox",
      variantIds: [42107179106374],
      qty: 1,
      maxChecked: 4,
      name: "Party packs",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions25,
    },
    {
      type: "checkbox",
      variantIds: [42107179106374],
      qty: 1,
      maxChecked: 1,
      name: "Snackie Box",
      label: "Choose 1 Snackie Box",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42107179139142],
      qty: 1,
      maxChecked: 1,
      name: "Snackie Box",
      label: "Choose 1 Snackie Box",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42107179139142],
      qty: 1,
      maxChecked: 1,
      name: "Goodie Box",
      label: "Choose 1 Goodie Box",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42135604363334],
      qty: 1,
      maxChecked: 3,
      name: "Goodie Box",
      label: "Choose up to 3 Goodie Boxes",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42107179204678],
      qty: 1,
      maxChecked: 3,
      name: "Gift Packs",
      label: "Choose up to 3 Gift Packs",
      snacks: popularSnackOptions95,
    },
    {
      type: "checkbox",
      variantIds: [42107179237446],
      qty: 1,
      maxChecked: 4,
      name: "Gift Packs",
      label: "Choose up to 4 Gift Packs",
      snacks: popularSnackOptions95,
    },
    {
      type: "checkbox",
      variantIds: [42107179270214],
      qty: 1,
      maxChecked: 6,
      name: "Gift Packs",
      label: "Choose up to 6 Gift Packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions95,
    },
    {
      type: "checkbox",
      variantIds: [42946765717574],
      qty: 1,
      maxChecked: 3,
      name: "Gift Packs",
      label: "Choose up to 3 Gift Packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions95,
    },
    {
      type: "checkbox",
      variantIds: [42946766405702],
      qty: 1,
      maxChecked: 1,
      name: "Gift Packs",
      label: "Choose 1 Gift Pack",
      snacks: popularSnackOptions95,
    },
    {
      type: "checkbox",
      variantIds: [42946766405702],
      qty: 1,
      maxChecked: 2,
      name: "Cutie Boxes",
      label: "Choose up to 2 Cutie Boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cutieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42946766635078],
      qty: 1,
      maxChecked: 2,
      name: "Gift Packs",
      label: "Choose up to 2 Gift Packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions95,
    },
    {
      type: "checkbox",
      variantIds: [42946766635078],
      qty: 1,
      maxChecked: 2,
      name: "Cutie Boxes",
      label: "Choose up to 2 Cutie Boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cutieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42946767126598],
      qty: 1,
      maxChecked: 4,
      name: "Cutie Boxes",
      label: "Choose up to 4 Cutie Boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cutieBoxOptions,
    },
  ],
  "trial-bundle": [
    {
      type: "checkbox",
      variantIds: ["all"], // apply to all
      qty: 1,
      maxChecked: 3,
      name: "snacks",
      label: "Choose up to 3 snacks",
      snacks: allSnackOptions,
    },
  ],
  "curated-snacks-custom-drinks-box-and-hamper": [
    {
      type: "checkbox",
      variantIds: [43457860796486],
      qty: 1,
      maxChecked: 1,
      name: "Party Packs",
      label: "Choose 4 Party Packs",
      snacks: popularSnackOptions25,
    },
    {
      type: "select",
      variantIds: [43457860796486],
      qty: 1,
      maxChecked: 1,
      name: "Drink",
      label: "Choose a drink",
      snacks: remedyOptions.concat(sodalyOptions),
    },
    {
      type: "select",
      variantIds: [39443911180358, 39287456890950, 39549578838086, 39287456923718],
      qty: 1,
      name: "Drink",
      label: "Select your drink",
      snacks: popularDrinkOptions,
    },
    {
      type: "select",
      variantIds: [39443911180358, 39287456890950, 39549578838086, 39287456923718],
      qty: 1,
      name: "Drink",
      label: "Select your drink",
      snacks: popularDrinkOptions,
    },
    {
      type: "select",
      variantIds: [39443911180358, 39287456890950, 39549578838086, 39287456923718],
      qty: 1,
      name: "Drink",
      label: "Select your drink",
      snacks: popularDrinkOptions,
    },
    {
      type: "select",
      variantIds: [39299615162438, 40161237663814],
      qty: 2,
      name: "Drink",
      label: "Select your drinks",
      snacks: popularDrinkOptions,
    },
  ],
  "nut-drink-rude-health": [
    {
      type: "checkbox",
      variantIds: [39814485278790],
      qty: 1,
      maxChecked: 2,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: rudeHealthOptions,
    },
    {
      type: "checkbox",
      variantIds: [39814485311558],
      qty: 1,
      maxChecked: 6,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: rudeHealthOptions,
    },
  ],
  "dash-sparkling-water": [
    {
      type: "checkbox",
      variantIds: [39355585462342, 39355585495110, 39408525541446],
      qty: 1,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: dashOptions,
    },
  ],
  "sodaly-prebiotic-soda": [
    {
      type: "checkbox",
      variantIds: [42310395232326, 42310395265094, 42310395297862],
      qty: 1,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: sodalyOptions,
    },
  ],
  "remedy-kombucha": [
    {
      type: "checkbox",
      variantIds: [39362966650950, 39408514334790, 39444732772422],
      qty: 1,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: remedyOptions,
    },
  ],
  "gryphon-tea": [
    {
      type: "checkbox",
      variantIds: [39411219103814],
      qty: 1,
      maxChecked: 3,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: gryphonOptions,
    },
    {
      type: "checkbox",
      variantIds: [39411219136582, 39411219202118],
      qty: 1,
      name: "Flavours",
      label: "Flavours (You can mix and match)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: gryphonOptions,
    },
  ],
  "xmas-snack-gift": [
    
  ],
  "cny-snack-box": [
    // ruby / huat cai
    {
      type: "textField",
      variantIds: [42241312227398],
      name: "Message",
      label: "Your message on card",
    },
    // ruby / heng ong huat
    {
      type: "textField",
      variantIds: [42193621811270],
      name: "Message",
      label: "Your message on card",
    },
    // ruby / fu lu shou
    {
      type: "textField",
      variantIds: [42193621844038],
      name: "Message",
      label: "Your message on card",
    },
    // floral / fortune
    {
      type: "checkbox",
      variantIds: [42193622138950],
      maxChecked: 2,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 2 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "display",
      variantIds: [42193622138950],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Abalone Creamy Macadamias in Goodie Box</li>
            <li>Oishi Japanese Nuts Medley in Goodie Box</li>
            <li>Sambal Shrimp Rolls in Snackie Box</li>
          </ol>
          `,
    },
    {
      type: "textField",
      variantIds: [42193622138950],
      name: "Message",
      label: "Your message on card",
    },
    // floral / bountiful
    {
      type: "checkbox",
      variantIds: [42193622171718],
      maxChecked: 1,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 1 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "display",
      variantIds: [42193622171718],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Abalone Creamy Macadamias in Goodie Box</li>
            <li>Supreme Popular Medley in Goodie Box</li>
            <li>Oishi Japanese Nuts Medley in Goodie Box</li>
            <li>Juicy Apricots in Goodie Box</li>
            <li>Floral Pineapple Tarts in Goodie Box</li>
            <li>Crunchy Medley in Goodie Box</li>
          </ol>
          `,
    },
    {
      type: "textField",
      variantIds: [42193622171718],
      name: "Message",
      label: "Your message on card",
    },
    // hamper / auspicious
    {
      type: "hamperDatePicker",
      variantIds: [42193622466630],
    },
    {
      type: "checkbox",
      variantIds: [42193622466630],
      maxChecked: 2,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 2 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "display",
      variantIds: [42193622466630],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Abalone Creamy Macadamias in Goodie Box</li>
            <li>Juicy Apricots in Goodie Box</li>
            <li>Floral Pineapple Tarts in Goodie Box</li>
            <li>Crunchy Medley in Goodie Box</li>
            <li>Arrowhead Crispy Chips</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    {
      type: "textField",
      variantIds: [42193622466630],
      name: "Message",
      label: "Your message on card",
    },
    // hamper / abundance
    {
      type: "hamperDatePicker",
      variantIds: [42193622499398],
    },
    {
      type: "checkbox",
      variantIds: [42193622499398],
      maxChecked: 2,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 2 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "display",
      variantIds: [42193622499398],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Abalone Creamy Macadamias in Goodie Box</li>
            <li>Supreme Popular Medley in Goodie Box</li>
            <li>Oishi Japanese Nuts Medley in Goodie Box</li>
            <li>Juicy Apricots in Goodie Box</li>
            <li>Floral Pineapple Tarts in Goodie Box</li>
            <li>Crunchy Medley in Goodie Box</li>
            <li>Sambal Shrimp Rolls in Snackie Box</li>
            <li>Huat Pineapple Tarts</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    {
      type: "textField",
      variantIds: [42193622499398],
      name: "Message",
      label: "Your message on card",
    },
    // hamper / prosperity
    {
      type: "hamperDatePicker",
      variantIds: [42193622532166],
    },
    {
      type: "checkbox",
      variantIds: [42193622532166],
      maxChecked: 2,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 2 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "display",
      variantIds: [42193622532166],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Abalone Creamy Macadamias in Goodie Box</li>
            <li>Supreme Popular Medley in Goodie Box</li>
            <li>Oishi Japanese Nuts Medley in Goodie Box</li>
            <li>Juicy Apricots in Goodie Box</li>
            <li>Floral Pineapple Tarts in Goodie Box</li>
            <li>Crunchy Medley in Goodie Box</li>
            <li>Sambal Shrimp Rolls in Snackie Box</li>
            <li>Jungle Medley in Snackie Box</li>
            <li>8 Treasures Platter with eight different flavours</li>
            <li>Huat Pineapple Tarts</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    {
      type: "textField",
      variantIds: [42193622532166],
      name: "Message",
      label: "Your message on card",
    },
    // hamper / longevity
    {
      type: "hamperDatePicker",
      variantIds: [42193622564934],
    },
    {
      type: "display",
      variantIds: [42193622564934],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Abalone Creamy Macadamias in Goodie Box</li>
            <li>Supreme Popular Medley in Goodie Box</li>
            <li>Oishi Japanese Nuts Medley in Goodie Box</li>
            <li>Juicy Apricots in Goodie Box</li>
            <li>Floral Pineapple Tarts in Goodie Box</li>
            <li>Crunchy Medley in Goodie Box</li>
            <li>Sambal Shrimp Rolls in Snackie Box</li>
            <li>Jungle Medley in Snackie Box</li>
            <li>8 Treasures Platter with eight different flavours</li>
            <li>Arrowhead Crispy Chips</li>
            <li>Kumquat Tarts</li>
            <li>Huat Pineapple Tarts</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    {
      type: "textField",
      variantIds: [42193622564934],
      name: "Message",
      label: "Your message on card",
    },
  ],
  "gourmet-snack-drink-hampers": [ 
    // Cheery
    {
      type: "checkbox",
      variantIds: [43675724709958],
      maxChecked: 3,
      qty: 1,
      name: "Retail packs",
      label: "Choose 3 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724709958],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724709958],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724709958],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Fabulous
    {
      type: "checkbox",
      variantIds: [43675724742726],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724742726],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724742726],
      maxChecked: 2,
      qty: 1,
      name: "Goodie box",
      label: "Choose 2 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724742726],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724742726],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Wonderful
    {
      type: "checkbox",
      variantIds: [43675724775494],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724775494],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724775494],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724775494],
      maxChecked: 2,
      qty: 1,
      name: "Bear bottle",
      label: "Choose 1 bear bottle",
      snacks: bearBottleOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724775494],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724775494],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Awesome
    {
      type: "checkbox",
      variantIds: [43675724808262],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724808262],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724808262],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724808262],
      maxChecked: 2,
      qty: 1,
      name: "Bear bottle",
      label: "Choose 1 bear bottle",
      snacks: bearBottleOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724808262],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43675724808262],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // add drink
    {
      type: "select",
      variantIds: [40839155482694],
      qty: 1,
      name: "drink",
      label: "Choose a drink",
      snacks: healthyDrinkOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [43675724709958, 43675724742726, 43675724775494, 43675724808262],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43675724709958, 43675724742726, 43675724775494, 43675724808262],
    },
    {
      type: "textField",
      variantIds: [43675724709958, 43675724742726, 43675724775494, 43675724808262],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "snack-hampers": [
    {
      type: "checkbox",
      variantIds: [42205317333062],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "checkbox",
      variantIds: [42205317333062],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Boxes",
      label: "Choose 4 Goodie Boxes",
      snacks: goodieBoxOptions,
    },
    // Shimmer
    {
      type: "checkbox",
      variantIds: [42205317365830],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "checkbox",
      variantIds: [42205317365830],
      maxChecked: 2,
      qty: 1,
      name: "Snackie Boxes",
      label: "Choose 2 Snackie Boxes",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42205317365830],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Boxes",
      label: "Choose 4 Goodie Boxes",
      snacks: goodieBoxOptions,
    },
    // Sparkles
    {
      type: "checkbox",
      variantIds: [42205317398598],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "checkbox",
      variantIds: [42205317398598],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Boxes",
      label: "Choose 4 Snackie Boxes",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42205317398598],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Boxes",
      label: "Choose 4 Goodie Boxes",
      snacks: goodieBoxOptions,
    },
    // Twinkles
    {
      type: "checkbox",
      variantIds: [42205317431366],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "checkbox",
      variantIds: [42205317431366],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Boxes",
      label: "Choose 4 Snackie Boxes",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42205317431366],
      maxChecked: 8,
      qty: 1,
      name: "Goodie Boxes",
      label: "Choose 8 Goodie Boxes",
      snacks: goodieBoxOptions,
    },
    {
      type: "display",
      variantIds: [42205317431366],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Fruitful Platter of 4 flavours in Coral Box</li>
            <li>Indulge Platter of 4 flavours in Coral Box</li>
            <li>Magical Jellybeans Candies Bear bottle</li>
            <li>Sweet Peach Candies Bear bottle</li>
          </ol>
          `,
    },
    // Radiance
    {
      type: "checkbox",
      variantIds: [42201035505734],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "checkbox",
      variantIds: [42201035505734],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Boxes",
      label: "Choose 4 Snackie Boxes",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42201035505734],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Boxes",
      label: "Choose 4 Goodie Boxes",
      snacks: goodieBoxOptions,
    },
    {
      type: "display",
      variantIds: [42201035505734],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Fruitful Platter of 4 flavours in Coral Box</li>
            <li>Indulge Platter of 4 flavours in Coral Box</li>
          </ol>
          `,
    },
    // Brillance
    {
      type: "checkbox",
      variantIds: [42201033080902],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: popularSnackOptions200,
    },
    {
      type: "checkbox",
      variantIds: [42201033080902],
      maxChecked: 4,
      qty: 1,
      name: "Snackie Boxes",
      label: "Choose 4 Snackie Boxes",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42201033080902],
      maxChecked: 4,
      qty: 1,
      name: "Goodie Boxes",
      label: "Choose 4 Goodie Boxes",
      snacks: goodieBoxOptions,
    },
    {
      type: "display",
      variantIds: [42201033080902],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Fruitful Platter of 4 flavours in Coral Box</li>
            <li>Indulge Platter of 4 flavours in Coral Box</li>
            <li>Magical Jellybeans Candies Bear bottle</li>
            <li>Sweet Peach Candies Bear bottle</li>
          </ol>
          `,
    },
    // all variants
    {
      type: "select",
      variantIds: [42205317333062, 42205317365830, 42205317398598, 42201035505734, 42201033080902, 42205317431366],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [42205317333062, 42205317365830, 42205317398598, 42201035505734, 42201033080902, 42205317431366],
    },
    {
      type: "textField",
      variantIds: [42205317333062, 42205317365830, 42205317398598, 42201035505734, 42201033080902, 42205317431366],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "congratulations-hampers": [
    // Cheery
    {
      type: "checkbox",
      variantIds: [43711646367814],
      maxChecked: 3,
      qty: 1,
      name: "Retail packs",
      label: "Choose 3 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646367814],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646367814],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646367814],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Fabulous
    {
      type: "checkbox",
      variantIds: [43711646400582],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646400582],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646400582],
      maxChecked: 2,
      qty: 1,
      name: "Goodie box",
      label: "Choose 2 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646400582],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646400582],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Wonderful
    {
      type: "checkbox",
      variantIds: [43711646433350],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646433350],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646433350],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646433350],
      maxChecked: 2,
      qty: 1,
      name: "Bear bottle",
      label: "Choose 1 bear bottle",
      snacks: bearBottleOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646433350],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646433350],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Awesome
    {
      type: "checkbox",
      variantIds: [43711646466118],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646466118],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646466118],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646466118],
      maxChecked: 2,
      qty: 1,
      name: "Bear bottle",
      label: "Choose 1 bear bottle",
      snacks: bearBottleOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646466118],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711646466118],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // add drink
    {
      type: "select",
      variantIds: [43711646498886],
      qty: 1,
      name: "drink",
      label: "Choose a drink",
      snacks: healthyDrinkOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [43711646367814, 43711646400582, 43711646433350, 43711646466118],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43711646367814, 43711646400582, 43711646433350, 43711646466118],
    },
    {
      type: "textField",
      variantIds: [43711646367814, 43711646400582, 43711646433350, 43711646466118],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "happy-birthday-hampers": [
    // Cheery
    {
      type: "checkbox",
      variantIds: [43711643385926],
      maxChecked: 3,
      qty: 1,
      name: "Retail packs",
      label: "Choose 3 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643385926],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643385926],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643385926],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Fabulous
    {
      type: "checkbox",
      variantIds: [43711643418694],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643418694],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643418694],
      maxChecked: 2,
      qty: 1,
      name: "Goodie box",
      label: "Choose 2 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643418694],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643418694],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Wonderful
    {
      type: "checkbox",
      variantIds: [43711643451462],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643451462],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643451462],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643451462],
      maxChecked: 2,
      qty: 1,
      name: "Bear bottle",
      label: "Choose 1 bear bottle",
      snacks: bearBottleOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643451462],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643451462],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Awesome
    {
      type: "checkbox",
      variantIds: [43711643484230],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643484230],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643484230],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643484230],
      maxChecked: 2,
      qty: 1,
      name: "Bear bottle",
      label: "Choose 1 bear bottle",
      snacks: bearBottleOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643484230],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711643484230],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [43711643385926, 43711643418694, 43711643451462, 43711643484230],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43711643385926, 43711643418694, 43711643451462, 43711643484230],
    },
    {
      type: "textField",
      variantIds: [43711643385926, 43711643418694, 43711643451462, 43711643484230],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "thank-you-hampers": [
    // Cheery
    {
      type: "checkbox",
      variantIds: [43711635390534],
      maxChecked: 3,
      qty: 1,
      name: "Retail packs",
      label: "Choose 3 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635390534],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635390534],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635390534],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Fabulous
    {
      type: "checkbox",
      variantIds: [43711635423302],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635423302],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635423302],
      maxChecked: 2,
      qty: 1,
      name: "Goodie box",
      label: "Choose 2 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635423302],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635423302],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Wonderful
    {
      type: "checkbox",
      variantIds: [43711635456070],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635456070],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635456070],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635456070],
      maxChecked: 2,
      qty: 1,
      name: "Bear bottle",
      label: "Choose 1 bear bottle",
      snacks: bearBottleOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635456070],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635456070],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Awesome
    {
      type: "checkbox",
      variantIds: [43711635488838],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635488838],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635488838],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635488838],
      maxChecked: 2,
      qty: 1,
      name: "Bear bottle",
      label: "Choose 1 bear bottle",
      snacks: bearBottleOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635488838],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [43711635488838],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // add drink
    {
      type: "select",
      variantIds: [43711635521606],
      qty: 1,
      name: "drink",
      label: "Choose a drink",
      snacks: healthyDrinkOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [43711635390534, 43711635423302, 43711635456070, 43711635488838],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43711635390534, 43711635423302, 43711635456070, 43711635488838],
    },
    {
      type: "textField",
      variantIds: [43711635390534, 43711635423302, 43711635456070, 43711635488838],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "happy-snacking-hampers": [
    // Cheery
    {
      type: "checkbox",
      variantIds: [41944042045510],
      maxChecked: 3,
      qty: 1,
      name: "Retail packs",
      label: "Choose 3 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042045510],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042045510],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042045510],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Fabulous
    {
      type: "checkbox",
      variantIds: [41944042078278],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042078278],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042078278],
      maxChecked: 2,
      qty: 1,
      name: "Goodie box",
      label: "Choose 2 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042078278],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042078278],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Wonderful
    {
      type: "checkbox",
      variantIds: [41944042111046],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042111046],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042111046],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042111046],
      maxChecked: 2,
      qty: 1,
      name: "Bear bottle",
      label: "Choose 1 bear bottle",
      snacks: bearBottleOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042111046],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042111046],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // Awesome
    {
      type: "checkbox",
      variantIds: [41944042143814],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042143814],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042143814],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042143814],
      maxChecked: 2,
      qty: 1,
      name: "Bear bottle",
      label: "Choose 1 bear bottle",
      snacks: bearBottleOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042143814],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "checkbox",
      variantIds: [41944042143814],
      maxChecked: 1,
      qty: 1,
      name: "Keychain",
      label: "Choose 1 keychain",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: icedGemKeyChainOptions,
    },
    // add drink
    {
      type: "select",
      variantIds: [41944042176582],
      qty: 1,
      name: "drink",
      label: "Choose a drink",
      snacks: healthyDrinkOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [41944042045510, 41944042078278, 41944042111046, 41944042143814],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [41944042045510, 41944042078278, 41944042111046, 41944042143814],
    },
    {
      type: "textField",
      variantIds: [41944042045510, 41944042078278, 41944042111046, 41944042143814],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "condolences-sympathy-hampers": [
    // Peace
    {
      type: "checkbox",
      variantIds: [43754415784006],
      maxChecked: 3,
      qty: 1,
      name: "Retail packs",
      label: "Choose 3 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415784006],
      maxChecked: 2,
      qty: 1,
      name: "Snackie box",
      label: "Choose 2 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415784006],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    // Solace
    {
      type: "checkbox",
      variantIds: [43754415816774],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415816774],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415816774],
      maxChecked: 4,
      qty: 1,
      name: "Drinks",
      label: "Choose 4 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    // Sympathies
    {
      type: "checkbox",
      variantIds: [43754415849542],
      maxChecked: 3,
      qty: 1,
      name: "Retail packs",
      label: "Choose 3 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415849542],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415849542],
      maxChecked: 2,
      qty: 1,
      name: "Goodie box",
      label: "Choose 2 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415849542],
      maxChecked: 2,
      qty: 1,
      name: "Drinks",
      label: "Choose 2 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "display",
      variantIds: [43754415849542],
      html: `Includes
          <ol style="padding: 1rem">
              <li>Fruitful Platter (4 types of dried fruits)</li>
          </ol>
          `,
    },
    // Condolences
    {
      type: "checkbox",
      variantIds: [43754415882310],
      maxChecked: 4,
      qty: 1,
      name: "Retail packs",
      label: "Choose 4 Retail Packs",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: hamperRetailPackOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415882310],
      maxChecked: 4,
      qty: 1,
      name: "Snackie box",
      label: "Choose 4 Snackie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: snackieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415882310],
      maxChecked: 4,
      qty: 1,
      name: "Goodie box",
      label: "Choose 4 Goodie Boxes",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: goodieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [43754415882310],
      maxChecked: 4,
      qty: 1,
      name: "Drinks",
      label: "Choose 4 Drinks",
      tooltip: "We will apportion your selected snacks equally if needed",
      snacks: healthyDrinkOptions,
    },
    {
      type: "display",
      variantIds: [43754415882310],
      html: `Includes
          <ol style="padding: 1rem">
              <li>Fruitful Platter (4 types of dried fruits)</li>
          </ol>
          `,
    },
    // add drink
    {
      type: "select",
      variantIds: [43754415915078],
      qty: 1,
      name: "drink",
      label: "Choose a drink",
      snacks: healthyDrinkOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [43754415784006, 43754415816774, 43754415849542, 43754415882310],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [43754415784006, 43754415816774, 43754415849542, 43754415882310],
    },
    {
      type: "textField",
      variantIds: [43754415784006, 43754415816774, 43754415849542, 43754415882310],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "wellness-healthy-hamper": [
    // vigor
    {
      type: "display",
      variantIds: [40834941648966],
      html: `Hamper contents
          <ol style="padding: 1rem">
            <strong>Retail Packs</strong>
              <li>Organic Chia Seeds</li>
              <li>Organic Cinnamon Granola</li>
            <strong>Snackie Boxes</strong>
              <li>Truly Veggie Medley</li>
              <li>Supreme Hearty Medley</li>
            <strong>Nut Butter</strong>
              <li>Organic Walnut Butter</li>
            <strong>Zero Sugar Drinks</strong>
              <li>Remedy Wild Berries Kombucha</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    // robust
    {
      type: "display",
      variantIds: [40834941681734],
      html: `Hamper contents
          <ol style="padding: 1rem">
            <strong>Retail Packs</strong>
              <li>Organic Chia Seeds</li>
              <li>Organic Cinnamon Granola</li>
              <li>Organic Pumpkin Seeds</li>
              <li>Worthy Hazelnut Oat Cookies</li>
            <strong>Snackie Boxes</strong>
              <li>Fruity Veggie Medley</li>
              <li>Supreme Hearty Medley</li>
            <strong>Goodie Boxes</strong>
              <li>Antioxidants Medley</li>
              <li>Cocoa Power Medley</li>
            <strong>Nut Butter</strong>
              <li>Organic Walnut Butter</li>
            <strong>Zero Sugar Drinks</strong>
              <li>Remedy Wild Berries Kombucha</li>
              <li>Remedy Mango Passion Kombucha</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    // strength
    {
      type: "display",
      variantIds: [40834941714502],
      html: `Hamper contents
          <ol style="padding: 1rem">
            <strong>Retail Packs</strong>
              <li>Organic Chia Seeds</li>
              <li>Organic Cinnamon Granola</li>
              <li>Organic Pumpkin Seeds</li>
              <li>Worthy Hazelnut Oat Cookies</li>
            <strong>Snack Platter</strong>
              <li>Fruitful Platter (4 types of dried fruits)</li>
            <strong>Snackie Boxes</strong>
              <li>Fruity Veggie Medley</li>
              <li>Supreme Hearty Medley</li>
            <strong>Goodie Boxes</strong>
              <li>Antioxidants Medley</li>
              <li>Cocoa Power Medley</li>
            <strong>Nut Butter</strong>
              <li>Organic Almond Butter</li>
              <li>Organic Walnut Butter</li>
            <strong>Zero Sugar Drinks</strong>
              <li>Remedy Wild Berries Kombucha</li>
              <li>Remedy Mango Passion Kombucha</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    // vitality
    {
      type: "display",
      variantIds: [40837544673350],
      html: `Hamper contents
          <ol style="padding: 1rem">
            <strong>Retail Packs</strong>
              <li>Organic Chia Seeds</li>
              <li>Organic Cinnamon Granola</li>
              <li>Organic Pumpkin Seeds</li>
              <li>Worthy Hazelnut Oat Cookies</li>
            <strong>Snack Platter</strong>
              <li>Fruitful Platter (4 types of dried fruits)</li>
            <strong>Snackie Boxes</strong>
              <li>Fruity Veggie Medley</li>
              <li>Truly Veggie Medley</li>
              <li>Supreme Brainy Medley</li>
              <li>Supreme Hearty Medley</li>
            <strong>Goodie Boxes</strong>
              <li>Antioxidants Medley</li>
              <li>Berry Nutty Medley</li>
              <li>Cocoa Power Medley</li>
              <li>Juicy Apricots</li> 
            <strong>Nut Butter</strong>
              <li>Organic Almond Butter</li>
              <li>Organic Walnut Butter</li>
            <strong>Zero Sugar Drinks</strong>
              <li>Remedy Wild Berries Kombucha</li>
              <li>Remedy Mango Passion Kombucha</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    // add drink
    {
      type: "select",
      variantIds: [41165570605126],
      qty: 1,
      name: "drink",
      label: "Choose a drink",
      snacks: healthyDrinkOptions,
    },
    // all variants
    {
      type: "select",
      variantIds: [40834941648966, 40834941681734, 40834941714502, 40837544673350],
      qty: 1,
      name: "Sticker design",
      label: "Select your sticker design",
      snacks: hamperStickerOptions,
    },
    {
      type: "hamperDatePicker",
      variantIds: [40834941648966, 40834941681734, 40834941714502, 40837544673350],
    },
    {
      type: "textField",
      variantIds: [40834941648966, 40834941681734, 40834941714502, 40837544673350],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "ndp-snack-box": [
    // steady hamper 
    {
      type: "display",
      variantIds: [43760282533958],
      html: `Hamper contents
      <p><strong>Retail Packs</strong></p>
        <ol style="padding: 0">
          <li>Satay Crunch Cashew</li>
          <li>Nasi Lemak Tapioca Chips</li>
          <li>Butter Murukku Crackres</li>
          <li>Shiok Salted Egg Peanuts</li>
        </ol>
      <p><strong>Goodie Boxes</strong></p>
        <ol style="padding: 0">
          <li>Nostalgic Iced Gem</li>
          <li>Merlion Butter Cookies</li>
          <li>Kacang Puteh Medley</li>
        </ol>
      <p><strong>Bonus</strong></p>
        <ol style="padding: 0">
          <li>Iced Gem Keychain</li>
        </ol>
      `,
    },
    // swee hamper
    {
      type: "display",
      variantIds: [43760282566726],
      html: `Hamper contents
      <p><strong>Retail Packs</strong></p>
        <ol style="padding: 0">
          <li>Satay Crunch Cashew</li>
          <li>Nasi Lemak Tapioca Chips</li>
          <li>Butter Murukku Crackres</li>
          <li>Shiok Salted Egg Peanuts</li>
        </ol>
      <p><strong>Goodie Boxes</strong></p>
        <ol style="padding: 0">
          <li>Nostalgic Iced Gem</li>
          <li>Merlion Butter Cookies</li>
          <li>Kacang Puteh Medley</li>
        </ol>
      <p><strong>Snackie Boxes</strong></p>
        <ol style="padding: 0">
          <li>Worthy Ondeh Ondeh Cookies</li>
        </ol>
      <p><strong>Bonus</strong></p>
        <ol style="padding: 0">
          <li>Organic Vegan Kaya</li>
          <li>Iced Gem Keychain</li>
        </ol>
      `,
    },
    // shiok hamper
    {
      type: "display",
      variantIds: [43760282599494],
      html: `Hamper contents
      <p><strong>Retail Packs</strong></p>
        <ol style="padding: 0">
          <li>Satay Crunch Cashew</li>
          <li>Nasi Lemak Tapioca Chips</li>
          <li>Butter Murukku Crackres</li>
          <li>Shiok Salted Egg Peanuts</li>
          <li>Happy Pineapple Tarts</li>
          <li>Abalone Creamy Macadamia</li>
        </ol>
      <p><strong>Goodie Boxes</strong></p>
        <ol style="padding: 0">
          <li>Nostalgic Iced Gem</li>
          <li>Merlion Butter Cookies</li>
          <li>Kacang Puteh Medley</li>
        </ol>
      <p><strong>Snackie Boxes</strong></p>
        <ol style="padding: 0">
          <li>Coffee Butter Cookies</li>
          <li>Worthy Ondeh Ondeh Cookies</li>
        </ol>
      <p><strong>Bonus</strong></p>
        <ol style="padding: 0">
          <li>Organic Vegan Kaya</li>
          <li>Iced Gem Keychain</li>
        </ol>
      `,
    },
    // sedap hamper
    {
      type: "display",
      variantIds: [43760282632262],
      html: `Hamper contents
      <p><strong>Retail Packs</strong></p>
        <ol style="padding: 0">
          <li>Satay Crunch Cashew</li>
          <li>Nasi Lemak Tapioca Chips</li>
          <li>Butter Murukku Crackres</li>
          <li>Shiok Salted Egg Peanuts</li>
          <li>Happy Pineapple Tarts</li>
          <li>Abalone Creamy Macadamia</li>
        </ol>
      <p><strong>Goodie Boxes</strong></p>
        <ol style="padding: 0">
          <li>Nostalgic Iced Gem</li>
          <li>Merlion Butter Cookies</li>
          <li>Kacang Puteh Medley</li>
        </ol>
      <p><strong>Snackie Boxes</strong></p>
        <ol style="padding: 0">
          <li>Coffee Butter Cookies</li>
          <li>Worthy Ondeh Ondeh Cookies</li>
          <li>Pecans Chocoalte Chip</li>
          <li>Flying Burger Balls</li>
        </ol>
      <p><strong>Bonus</strong></p>
        <ol style="padding: 0">
          <li>Organic Vegan Kaya</li>
          <li>Iced Gem Keychain</li>
          <li>Merlion Keychain</li>
        </ol>
      `,
    },
    // all variants
    {
      type: "hamperDatePicker",
      variantIds: [43760282533958, 43760282566726, 43760282599494, 43760282632262],
    },
    {
      type: "textField",
      variantIds: [43760282533958, 43760282566726, 43760282599494, 43760282632262],
      name: "Message",
      label: "Your message on card (optional)",
    },
  ],
  "nutty-mooncakes": [
    {
      type: "checkbox",
      variantIds: [40649355919430],
      qty: 2,
      maxChecked: 2,
      name: "Mooncakes",
      label: "Choose 2 mooncakes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: mooncakeFlavours,
    },
    {
      type: "checkbox",
      variantIds: [40649355919430],
      qty: 4,
      maxChecked: 4,
      name: "Gift packs",
      label: "Choose 2 gift packs",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions95,
    },
    {
      type: "checkbox",
      variantIds: [40073557803078],
      qty: 2,
      maxChecked: 2,
      name: "Mooncakes",
      label: "Choose 2 mooncakes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: mooncakeFlavours,
    },
    {
      type: "checkbox",
      variantIds: [40073557803078],
      qty: 2,
      maxChecked: 2,
      name: "Cutie box",
      label: "Choose 2 cutie boxes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: cutieBoxOptions,
    },
    {
      type: "checkbox",
      variantIds: [42048207978566],
      qty: 4,
      maxChecked: 4,
      name: "Mooncakes",
      label: "Choose 4 mooncakes",
      tooltip: "We will apportion your selected flavours equally",
      snacks: mooncakeFlavours,
    },
    
  ],
  "deepavali-diwali-snack-box": [
    {
      type: "hamperDatePicker",
      variantIds: [40698504118342, 40718781317190, 42191049654342],
    },
    // Puja Hamper
    {
      type: "display",
      variantIds: [40698504118342],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Butter Murukku Crackers</li>
            <li>Spicy Murukku Crackers</li>
            <li>Star Murukku Crackers</li>
            <li>Butter Murukku Crackers in Snackie Box</li>
            <li>Sambal Shrimp Rolls in Snackie Box</li>
            <li>Mithai Platter in Coral Box (4 types of dried fruits)</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    // Diya Hamper
    {
      type: "display",
      variantIds: [40718781317190],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Butter Murukku Crackers</li>
            <li>Spicy Murukku Crackers</li>
            <li>Star Murukku Crackers</li>
            <li>Butter Murukku Crackers Snackie Box</li>
            <li>Sambal Shrimp Rolls Snackie Box</li>
            <li>Worthy Coconut Earl Grey Goodie Box</li>
            <li>Crunchy Medley Goodie Box</li>
            <li>Oishi Japanese Nuts Medley Goodie Box</li>
            <li>Mithai Platter in Coral Box (4 types of dried fruits)</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    // Diya Hamper
    {
      type: "display",
      variantIds: [42191049654342],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Butter Murukku Crackers</li>
            <li>Spicy Murukku Crackers</li>
            <li>Star Murukku Crackers</li>
            <li>Butter Murukku Crackers Snackie Box</li>
            <li>Sambal Shrimp Rolls Snackie Box</li>
            <li>Cocoa Power Medley Snackie Box</li>
            <li>Supreme Honey Medley Snackie Box</li>
            <li>Worthy Coconut Earl Grey Goodie Box</li>
            <li>Crunchy Medley Goodie Box</li>
            <li>Mithai Platter in Coral Box (4 types of dried fruits)</li>
            <li>Party Platter in Coral Box (6 types of party snacks)</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    {
      type: "textField",
      variantIds: [40698504118342, 40718781317190, 42191049654342],
      name: "Message",
      label: "Your message on card",
    },
  ],
  "mothers-day-snack-box": [
    {
      type: "checkbox",
      variantIds: [40837548081222],
      qty: 2,
      maxChecked: 2,
      name: "Retail packs",
      label: "Choose up to 2 retail packs",
      snacks: bestMomDad200,
    },
  ],
  "hari-raya-snack-box": [
    {
      type: "select",
      variantIds: [40502542303302],
      qty: 1,
      name: "drink",
      label: "Choose a drink",
      snacks: remedyOptions,
    },
    // Mubarak Hamper
    {
      type: "hamperDatePicker",
      variantIds: [42330920550470],
    },
    {
      type: "checkbox",
      variantIds: [42330920550470],
      maxChecked: 2,
      qty: 1,
      name: "Hari Raya Specials",
      label: "Choose 2 Hari Raya Specials",
      snacks: hariRayaSpecials,
    },
    {
      type: "checkbox",
      variantIds: [42330920550470],
      maxChecked: 2,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 2 Retail Packs",
      snacks: hariRayaSnacks200,
    },
    {
      type: "display",
      variantIds: [42330920550470],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Sugar Sweet Peanuts in Goodie Box</li>
            <li>Crunchy Medley in Goodie Box</li>
            <li>Juicy Apricots in Goodie Box</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    {
      type: "textField",
      variantIds: [42330920550470],
      name: "Message",
      label: "Your message on card",
    },
    // Kenduri Hamper
    {
      type: "hamperDatePicker",
      variantIds: [42330920583238],
    },
    {
      type: "checkbox",
      variantIds: [42330920583238],
      maxChecked: 4,
      qty: 1,
      name: "Retail Packs",
      label: "Choose 4 Retail Packs",
      snacks: hariRayaSnacks200,
    },
    {
      type: "display",
      variantIds: [42330920583238],
      html: `Included in the package
          <ol style="padding: 1rem">
            <li>Pandan Makmur Cookies</li>
            <li>Pandan Pineapple Tarts</li>
            <li>Colourful Donut Cookies</li>
            <li>Lazat Cornflake Cookies</li>
            <li>Sugar Sweet Peanuts in Goodie Box</li>
            <li>Crunchy Medley in Goodie Box</li>
            <li>Juicy Apricots in Goodie Box</li>
            <li>Sambal Shrimp Rolls in Snackie Box</li>
          </ol>
          Packed and wrapped as hamper
          `,
    },
    {
      type: "textField",
      variantIds: [42330920583238],
      name: "Message",
      label: "Your message on card",
    },
  ],
  "nuts-about-you-snack-gift-box": [
    {
      type: "checkbox",
      variantIds: [40488552202310, 40488552235078, 40488540799046, 40837552373830],
      maxChecked: 2,
      qty: 1,
      name: "Snacks",
      label: "Choose up to 2 snacks",
      tooltip: "We will apportion your selected snacks equally",
      snacks: nutsAboutYouSnacks200,
    },
    {
      type: "select",
      variantIds: [40837555912774],
      qty: 1,
      name: "drink",
      label: "Choose a drink",
      snacks: popularDrinkOptions,
    },
  ],
  "snack-party-cones": [
    {
      type: "checkbox",
      variantIds: [42016747192390, 42016747225158, 42016747257926],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 4 flavours",
      tooltip: "We will apportion your selected snacks equally",
      snacks: snackConeOptions,
    },
  ],
  "wedding-favours": [
    {
      type: "checkbox",
      variantIds: [40505270665286, 40505270698054, 40706652405830],
      maxChecked: 4,
      qty: 1,
      name: "Flavours",
      label: "Flavours (Up to 4)",
      tooltip: "We will apportion your selected flavours equally",
      snacks: popularSnackOptions25,
    },
    {
      type: "imageSelect",
      variantIds: [40505270665286, 40505270698054, 40706652405830],
      qty: 1,
      name: "Label",
      label: "Choose your label",
      tooltip: "Size (LxH): 5cm x 5cm",
      images: weddingImageOptions.concat([
        {
          name: "Custom",
          url: "https://cdn.shopify.com/s/files/1/1717/9065/files/Custom_label.jpg?v=1692952705",
        },
      ]),
    },
    {
      type: "textField",
      variantIds: [40505270665286, 40505270698054, 40706652405830],
      name: "Names (for named labels)",
      label: "Names",
    },
  ],
  "build-your-own-mix": [
    {
      type: "custom-medley",
      variantIds: [43783275380806],
      maxChecked: 5,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 5 ingredients",
      snacks: customMedleyOptions,
      // custom field
      totalWeight: 200,
    },
    {
      type: "custom-medley",
      variantIds: [43783275413574, 43783275479110],
      maxChecked: 5,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 5 ingredients",
      snacks: customMedleyOptions,
      // custom field
      totalWeight: 500,
    },
    {
      type: "custom-medley",
      variantIds: [43783275446342],
      maxChecked: 5,
      qty: 1,
      name: "Flavours",
      label: "Choose up to 5 ingredients",
      snacks: customMedleyOptions,
      // custom field
      totalWeight: 1000,
    },
  ],
};

if (!customElements.get("custom-options")) {
  customElements.define(
    "custom-options",
    class CustomOptions extends HTMLElement {
      constructor() {
        super();
        this.options = routeOptions;
      }

      connectedCallback() {
        try {
          // Parse options from the data attribute
          // this.options = JSON.parse(this.dataset.options || "{}");

          // Get product handle and variant ID
          const productHandle = this.dataset.productHandle;
          const variantId = parseInt(this.dataset.variantId, 10);

          // Match options for the product handle and variant ID
          const matchedOptions =
            this.options[productHandle]?.filter((option) => option.variantIds.includes(variantId) || option.variantIds[0] === "all" ) || [];

          // Render the matched options
          if (matchedOptions.length > 0) {
            this.renderOptions(matchedOptions);
          } else {
            console.log(`No matching options found for product ${productHandle} with variant ID ${variantId}`);
          }

          // if we need to handle variant changes, we can subscribe to the event publish inside product-info.js
          // this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          //   const { sectionId, html, variant } = event.data;

          //   // Handle the event (e.g., update custom options based on the new variant)
          //   console.log("Variant changed:", { sectionId, html, variant });
          // });
        } catch (error) {
          console.error("Error in custom-options component:", error);
        }
      }

      // Uncomment if you need to handle variant changes
      // disconnectedCallback() {
      //   // Unsubscribe from the event to avoid memory leaks
      //   this.variantChangeUnsubscriber?.();
      // }

      renderOptions(matchedOptions) {
        if (!matchedOptions || matchedOptions.length === 0) return;

        const formId = this.dataset.formId || "product-form";

        matchedOptions.forEach((option) => {
          if (!option || !option.type) {
            console.warn("Invalid option object:", option);
            return;
          }

          let html = "";

          try {
            switch (option.type) {
              case "checkbox":
                if (typeof renderCheckBoxes === "function" && option.snacks) {
                  html = renderCheckBoxes(option, formId);
                } else {
                  console.warn(`renderCheckBoxes function not found or option.snacks is missing for option:`, option);
                }
                break;
              case "imageSelect":
                if (typeof renderImageHtml === "function" && option.images) {
                  html = renderImageHtml(option, formId);
                } else {
                  console.warn(`renderImageHtml function not found or option.images is missing for option:`, option);
                }
                break;
              case "file":
                if (typeof renderFileUpload === "function") {
                  html = renderFileUpload(option, formId);
                } else {
                  console.warn(`renderFileUpload function not found for option:`, option);
                }
                break;
              case "display":
                if (typeof renderDisplayHtml === "function" && option.html) {
                  html = renderDisplayHtml(option);
                } else {
                  console.warn(`renderDisplayHtml function not found or option.html is missing for option:`, option);
                }
                break;
              case "select":
                if (typeof renderSelect === "function" && option.snacks) {
                  html = renderSelect(option, formId);
                } else {
                  console.warn(`renderSelect function not found or option.snacks is missing for option:`, option);
                }
                break;
              case "date":
                if (typeof renderDate === "function") {
                  html = renderDate(option, formId);
                } else {
                  console.warn(`renderDate function not found for option:`, option);
                }
                break;
              case "timeslot":
                if (typeof renderTimeSlot === "function") {
                  html = renderTimeSlot(option, formId);
                } else {
                  console.warn(`renderTimeSlot function not found for option:`, option);
                }
                break;
              case "hamperDatePicker":
                if (typeof renderHamperDatePicker === "function") {
                  html = renderHamperDatePicker(option, formId);
                } else {
                  console.warn(`renderHamperDatePicker function not found for option:`, option);
                }
                break;
              case "textField":
                if (typeof renderTextArea === "function") {
                  html = renderTextArea(option, formId);
                } else {
                  console.warn(`renderTextArea function not found for option:`, option);
                }
                break;
              case "custom-medley":
                if (typeof renderCustomMedley === "function") {
                  html = renderCustomMedley(option, formId);
                } else {
                  console.warn(`renderCustomMedley function not found for option:`, option);
                }
                break;
              default:
                console.warn(`Unknown option type: ${option.type}`);
            }

            // Wrap the generated HTML in a div with class "option-group"
            if (html) {
              const wrappedHtml = `<div class="options accordion option-group">${html}</div>`;
              this.insertAdjacentHTML("beforeend", wrappedHtml);
            }
          } catch (error) {
            console.error(`Error rendering option type ${option.type}:`, error);
          }
        });

        renderFlatPickr();

        // Add popular choices indicator
        if (typeof addPopularChoices === "function") {
          try {
            addPopularChoices();
          } catch (error) {
            console.error("Error adding popular choices:", error);
          }
        }
      }
      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector("variant-selects [data-selected-variant]")?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }
    }
  );
}
